/****
 *	Utility to set and get the campaign ID from email / social media campaigns
 **/

const urlUtilities = require('utilities/urlUtilities');
const campaignId = urlUtilities.getSearchParameter('campaignId') || urlUtilities.getSearchParameter('utm_campaign');
const source = urlUtilities.getSearchParameter('source') || urlUtilities.getSearchParameter('utm_source');
const category = urlUtilities.getSearchParameter('category') || urlUtilities.getSearchParameter('utm_medium');
const model = require('model/model');

const setCampaignId = () => {
	model.set('campaignId', campaignId);
};

const getCampaignId = () => {
	return model.get('campaignId');
};

const removeCampaignCookie = () => {
	return model.remove('campaignId');
};

const setSource = () => {
	model.set('source', source);
};

const getSource = () => {
	return model.get('source');
};

const removeSourceCookie = () => {
	return model.remove('source');
};

const setCategory = () => {
	model.set('category', category);
};

const getCategory = () => {
	return model.get('category');
};

const removeCategoryCookie = () => {
	return model.remove('category');
};

if (campaignId) {
	setCampaignId();
}

if (source) {
	setSource();
}

if (category) {
	setCategory();
}

module.exports = {
	getCampaignId,
	removeCampaignCookie,
	getSource,
	removeSourceCookie,
	getCategory,
	removeCategoryCookie
};
